var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"column"},[_c('div',{staticClass:"noBox"}),_c('h1',[_vm._v(_vm._s(_vm.$t('noAccess.title')))]),_c('p',[_vm._v(_vm._s(_vm.$t('noAccess.pleaseContactAdmin')))])])])}
var staticRenderFns = []

export { render, staticRenderFns }